export default "/images/ed6128da37997248a97e649b5f86a0c9.avif";